import { useState } from "react"

const Feedback = ({ handleFeedbackSend }) => {

    const [isVisible, setIsVisible]=  useState(false)
    const [feedback, setFeedback] = useState("")

    return (
        <div className="feedback">
            {isVisible && <div className="feedback-form">
                <label>Let us know if you faced any errors or have any feature requests?</label>
                <textarea value={feedback} onChange={e => setFeedback(e.target.value)}></textarea>
                <button className="button-50" onClick={() => { handleFeedbackSend(feedback); console.log('feedback.js', feedback) }}>send</button>
            </div>}
            <button className="feedback-toggle button-50"  onClick={() => { setIsVisible(isVisible => !isVisible) }}>got feedback ?</button>
        </div>
    )

}

export default Feedback